module.exports = __webpack_public_path__ + "media/images/test/example-e39e62a28ea9b0c84983f8cefc0e5fc3.pdf";